<sh-form-label [label]="label" [for]="id" [class.sh-visually-hidden]="!isHeader"> </sh-form-label>
<ng-container [ngSwitch]="valueType$ | async">
    <sh-form-text-base
        *ngSwitchCase="ValueType.Text"
        [id]="id"
        [formControl]="internalControl"
        [autocompleteFct]="autocompleteFunction$ | async"
        [inOverflownContainer]="true"
        class="sh-form-group__input"
    ></sh-form-text-base>
    <sh-form-text-base
        *ngSwitchCase="ValueType.LongText"
        [id]="id"
        [formControl]="internalControl"
        [inOverflownContainer]="true"
        class="sh-form-group__input"
    ></sh-form-text-base>
    <sh-form-number-base *ngSwitchCase="ValueType.Number" [id]="id" [formControl]="internalControl" class="sh-form-group__input"></sh-form-number-base>
    <sh-form-multi-select
        *ngSwitchCase="ValueType.Group"
        [id]="id"
        [control]="internalControl"
        [search]="true"
        [inOverflownContainer]="true"
        [searchPlaceholderMsg]="searchPlaceholder"
        [options]="fieldDefinitionOptions"
        [noResultsFoundMsg]="i18n.search.noResultsMsg"
        [listCappedMsg]="i18n.search.listCappedMsg"
        [limitHeightToViewport]="true"
        (searchTerm)="onSearchTermChanged($event)"
        class="sh-form-group__input"
    ></sh-form-multi-select>
    <sh-form-multi-select
        *ngSwitchCase="ValueType.Option"
        [id]="id"
        [control]="internalControl"
        [search]="true"
        [inOverflownContainer]="true"
        [searchPlaceholderMsg]="searchPlaceholder"
        [options]="fieldDefinitionOptions"
        [noResultsFoundMsg]="i18n.search.noResultsMsg"
        [listCappedMsg]="i18n.search.listCappedMsg"
        [limitHeightToViewport]="true"
        (searchTerm)="onSearchTermChanged($event)"
        class="sh-form-group__input"
    ></sh-form-multi-select>
    <sh-form-input-with-droppanel
        *ngSwitchCase="ValueType.Date"
        [id]="id"
        [label]="dateLabel$ | async"
        [variant]="variant"
        [droppanelStyle]="droppanelStyle"
        [inOverflownContainer]="true"
    >
        <div class="sh-droppanel__content">
            <div class="sh-form-group__input">
                <sh-form-date-select
                    [id]="id + '-from'"
                    [control]="fromControl"
                    [label]="i18n.value.date.from"
                    [yearLabel]="i18n.value.date.year"
                    [monthLabel]="i18n.value.date.month"
                    [dayLabel]="i18n.value.date.day"
                    [limitHeightToViewport]="true"
                ></sh-form-date-select>
                <sh-form-date-select
                    [id]="id + '-until'"
                    [control]="untilControl"
                    [label]="i18n.value.date.to"
                    [yearLabel]="i18n.value.date.year"
                    [monthLabel]="i18n.value.date.month"
                    [dayLabel]="i18n.value.date.day"
                    [limitHeightToViewport]="true"
                ></sh-form-date-select>
            </div>
        </div>
    </sh-form-input-with-droppanel>
</ng-container>
